<template>
  <div>
    <h1>Access Denied</h1>
    <p>
      You need the <strong>HealthyPet</strong> token in your wallet to access
      this page.
    </p>
    <p>Here’s how you can get HealthyPet tokens:</p>
    <ul>
      <li>
        Visit our official website:
        <a href="https://HealthyPet.io" target="_blank">HealthyPet.io</a>
      </li>
      <li>
        Purchase on supported marketplaces like
        <a href="https://www.dexlab.space" target="_blank">DexLab</a>.
      </li>
    </ul>
    <p>
      Once you have the HealthyPet token in your wallet, refresh the page to
      access the dashboard.
    </p>
    <router-link to="/">Return to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "NoAccessView",
};
</script>

<style>
h1 {
  color: red;
  margin-bottom: 20px;
}
p {
  font-size: 18px;
  margin-bottom: 10px;
}
ul {
  list-style-type: disc;
  margin-left: 20px;
}
a {
  color: blue;
  text-decoration: underline;
}
</style>
